<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <div class="flex items-start flex-col sm:flex-row">
        <div v-if="userId">
          <img v-if="imageLocal" :src="imageLocal" class="mr-8 rounded h-24 w-24"/>
          <img v-else :src="require('@/assets/images/avatar.png')" class="mr-8 rounded w-20 w-20"/>
        </div>
        <div v-else>
          <img v-if="previewImageUrl" :src="previewImageUrl" class="mr-8 rounded h-24 w-24"/>
          <img v-else :src="require('@/assets/images/avatar.png')" class="mr-8 rounded w-20 w-20"/>
        </div>
        <div>
          <p class="text-lg font-medium mb-2 mt-4 sm:mt-0" v-text="title"></p>
          <input type="file" class="hidden" ref="update_avatar_input" @change="changeProfileAvatar"
                 accept="image/jpeg, image/png">
          <vs-button type="border" class="mr-4" @click="$refs.update_avatar_input.click()"> انتخاب تصویر</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AvatarUploader",
    data() {
      return {
        imageLocal: this.image,
        previewImageUrl:''
      }
    },
    computed: {},
    methods: {
      changeProfileAvatar(ev) {
        let reader = new FileReader()
        reader.readAsBinaryString(ev.target.files[0])
        this.previewImageUrl = URL.createObjectURL(ev.target.files[0]);
        let extension = ev.target.files[0].name.split('.').pop()
        reader.onload = () => {
          let params = {
            context: this.context,
            id: this.userId,
            photo: btoa(reader.result),
            format: extension === 'jpeg' ? 'jpg' : extension
          };
          if(!this.userId){
            this.$emit('change',params)
            return
          }
          this.$store.dispatch('uploadProfileAvatar',params).then(url => {
            this.imageLocal = url
            this.$vs.notify({title: 'تصویر پروفایل آپلود شد', text: '', color: 'success', position: 'top-center'})
          })
            .catch(() => {
              this.$vs.notify({title: 'مشکل در اپلود تصویر', text: '', color: 'danger', position: 'top-center'})
            })
        };
      }
    },
    props: {
      context: {
        Type: String,
        default: 'user'
      },
      image: {
        Type: String,
        default: ''
      },
      title: {
        Type: String,
        default: 'تصویر پروفایل'
      },
      userId: [Number]
    }
  }
</script>

<style scoped>

</style>
